import axios from "axios";
import { baseURL } from "../api";

export const errorToString = (error) => {
  if (!error) return ''
  let finalError = "";

  if (typeof error?.data?.message === "string") {
    finalError = error?.data?.message;
  } else if (typeof error?.data?.error?.message === "string") {
    finalError = error?.data?.error?.message;
  } else if (typeof error?.data?.errors === "string") {
    finalError = error?.data?.errors;
  } else if (error?.data?.errors) {
    let err = error?.data?.errors;
    Object.keys(err).forEach((key) => {
      let msg = "";
      if (typeof err[key] === "string") {
        msg = err[key];
      } else if (Array.isArray(err[key])) {
        msg = err[key].join(", ");
      }
      if (finalError) {
        finalError += `<br />`;
      }
      finalError += `${key} : ${msg}`;
    });
  }

  return (
    finalError ||
    "There is some error to complete the request, please try again ..."
  );
};

export const nFormatter = (num, digits = 1) => {
  const lookup = [
    { value: 1, symbol: "" },
    { value: 1e3, symbol: "k" },
    { value: 1e6, symbol: "M" },
    { value: 1e9, symbol: "G" },
    { value: 1e12, symbol: "T" },
    { value: 1e15, symbol: "P" },
    { value: 1e18, symbol: "E" },
  ];
  const rx = /\.0+$|(\.[0-9]*[1-9])0+$/;
  var item = lookup
    ?.slice()
    ?.reverse()
    ?.find(function (item) {
      return num >= item.value;
    });
  return item
    ? (num / item.value).toFixed(digits).replace(rx, "$1") + item.symbol
    : "0";
};

export const getParams = (data) => {
  return Object.keys(data)
    .map((key) => `${key}=${encodeURIComponent(data[key])}`)
    .join("&");
};

export const validateUrl = (url) => {
  if (url.includes("http")) {
    return url;
  } else {
    return "https://" + url;
  }
};

export function deleteAllParams() {
  window.history.replaceState(null, "", window.location.pathname);
}


export const isEventManager = false

export const convertMentions = (text, isPlanText = false) => {
  // Regular expression to match @[Name](user:id) where 'id' can include any character including hyphens
  const mentionRegex = /@\[([^\]]+)\]\(user:([^)]+)\)/g;

  // Replace each mention with <span> element
  const convertedText = text.replace(mentionRegex, (match, name, id) => {
    if (isPlanText) return name;
    return `<a href="/user/${id}" class="tagged-user" id="${id}">${name}</a>`;
  });

  return convertedText;
}

export const shareLink = ({ id, content = '', image = '', premiumPost = content?.includes('{PremiumPicture}') }) => {
  const postUrl = `${baseURL}/api/v1/feed/share/${id}/${premiumPost ? '2' : '1'}`;
  const fbShareUrl = `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(postUrl)}`;

  console.log("shareLink postUrl => ", postUrl);

  // Tell Facebook to re-scrape the URL so OG tags are fresh (fire and forget, deferred so
  // it does NOT run before navigator.share / window.open — keeps the user gesture active)
  setTimeout(() => {
    axios({
      method: 'POST',
      url: `https://graph.facebook.com/?id=${encodeURIComponent(postUrl)}&scrape=true&access_token=915432106082628|gBjPjcbHMcMTdaut47mjkmt0uy4`,
      timeout: 4000,
    }).catch(() => {});
  }, 0);

  const ua = navigator.userAgent;
  const isIOS = /iPhone|iPad|iPod/i.test(ua);
  const isAndroid = /Android/i.test(ua);
  const isMobile = isIOS || isAndroid;

  if (navigator?.share) {
    // navigator.share() is called synchronously inside the user-gesture context.
    // We use .catch() instead of await so the function stays synchronous — this
    // prevents Chrome from treating any subsequent window.open() as a popup and blocking it.
    navigator.share({ url: postUrl, title: 'Check this out on iCompete!' }).catch(() => {});
    return;
  }

  if (isMobile) {
    // Mobile without navigator.share (very old Android, some in-app browsers)
    window.open(fbShareUrl, '_blank', 'noopener,noreferrer');
  } else {
    // Desktop: open a centred popup
    const width = 600;
    const height = 450;
    const left = Math.max(0, (window.screen.width - width) / 2);
    const top = Math.max(0, (window.screen.height - height) / 2);
    window.open(fbShareUrl, 'fb-share', `width=${width},height=${height},left=${left},top=${top},scrollbars=yes`);
  }
};
// The API returns the currency as a code (e.g. "INR"). Show the rupee symbol
// for INR and fall back to whatever the API sent for every other currency.
export const currencySign = (sign) =>
  String(sign || "").trim().toUpperCase() === "INR" ? "₹" : sign;
